import { createAsyncThunk, createAction } from '@reduxjs/toolkit'
import type { RootState } from 'app'
import { CompanySearchResult, Company, LoadingStatus } from 'shared/types'
import Api, { paths } from 'shared/services/Api'
import { getAccountantCompaniesState } from './selectors'

const NAMESPACE = 'companies'

export const selectCompanyId = createAction<number | string>(
  `${NAMESPACE}/selectCompanyId`
)

export const clearCompanySelection = createAction(
  `${NAMESPACE}/clearCompanySelection`
)

export const searchCompanies = createAsyncThunk<
  CompanySearchResult,
  { taxNumber: string },
  { rejectValue: string }
>(`${NAMESPACE}/searchCompanies`, async ({ taxNumber }, thunkAPI) => {
  try {
    const response = await Api.get(paths.Companies.search, {
      params: {
        taxNumber,
      },
    })
    return response.data
  } catch (error) {
    return thunkAPI.rejectWithValue(error)
  }
})

export const getAccountantCompanies = createAsyncThunk<
  Company[],
  { disableRefetch: boolean } | undefined,
  { rejectValue: string }
>(
  `${NAMESPACE}/getAccountantCompanies`,
  async (_, thunkAPI) => {
    try {
      const response = await Api.get(paths.Accountants.companies)
      return response.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
  {
    condition: (options, { getState }) => {
      const { loading } = getAccountantCompaniesState(getState() as RootState)
      if (
        (loading === LoadingStatus.Succeeded ||
          loading === LoadingStatus.Pending) &&
        options?.disableRefetch
      ) {
        return false
      }
    },
  }
)
